module.exports = __webpack_public_path__ + "img/SCROLL-ARROW.48acecee.png";